
    <ng-container *ngIf="formControlItem; else noFormControl">
        <div class="grid grid-cols-8 items-center space-x-4  rounded-lg">
            <ng-container *ngIf="label">
                <label [for]="id" class="{{labelClass}} col-span-3 block text-normal text-center text-sm font-medium leading-6">{{label | translate}}</label>
            </ng-container>
            <div class="flex items-center space-x-4" [ngClass]="{
                'col-span-5': label,
                'col-span-8': !label
            }">
                <input
                    #currentElement
                    [id]="id"
                    [formControl]="formControlItem"
                    [name]="id"
                    [ngClass]="customClasses"
                    autocomplete="off"
                    [placeholder]="(placeholder || '') | translate"
                    (input)="valueChange($event)"
                    [step]="step"
                    type="range"
                    [min]="min"
                    [max]="max"
                    class="w-full accent-primary"
                />
                <input
                        type="number"
                        [formControl]="formControlItem"
                        (input)="valueChange($event)"
                        (blur)="onBlur()"
                        [min]="min"
                        [max]="max"
                        class="bg-gray-800 text-gray-300 text-center w-14 p-1 rounded border border-gray-600"
                />
                <span class="text-gray-400 !ml-[5px] pr-5 text-nowrap text-sm">{{ metrica | translate}}</span>
            </div>
        </div>
        <ng-container>
            <app-validation-error [control]="formControlItem "  class="text-red-500 text-xs italic"></app-validation-error>
        </ng-container>
    </ng-container>

    <ng-template #noFormControl>
        <div class="flex items-center space-x-4  p-y-4 rounded-lg">
            <ng-container *ngIf="label">
                <label [for]="id" class="{{labelClass}} block  text-nowrap text-normal text-center text-sm font-medium leading-6">{{label | translate}}</label>
            </ng-container>
            <input
                #currentElement
                [id]="id"
                [value]="value"
                [ngClass]="customClasses"
                autocomplete="off"
                [placeholder]="(placeholder || '') | translate"
                (input)="valueChange($event)"
                (blur)="onBlur()"
                [step]="step"
                type="range"
                [min]="min"
                [max]="max"
                [(ngModel)]="value"
                class="w-full accent-orange-500"
            />
            <input
                    type="number"
                    [(ngModel)]="value"
                    (input)="valueChange($event)"
                    (blur)="onBlur()"
                    [min]="min"
                    [max]="max"
                    class="bg-gray-800 text-gray-300 text-center w-14 p-1 rounded border border-gray-600"
            />
            <span class="text-gray-400 !ml-[5px] pr-5 text-nowrap overflow-hidden text-sm">{{ metrica | translate}}</span>
        </div>
    </ng-template>